import styled, { css } from 'styled-components';
import { Link } from '@reach/router';
import { lightGrey3Color } from 'js/config/style';

const linkStyle = css`
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.5rem 0;
  color: ${lightGrey3Color};
`;

export const MenuLink = styled(Link)`
  ${linkStyle}

  color: ${({ highlight }) => (highlight ? 'black' : lightGrey3Color.darken())};

  &:hover {
    color: ${lightGrey3Color.darken(3)};
  }

  &:active {
    color: black;
  }
`;

export const MenuLabel = styled.span`
  ${linkStyle}
  cursor: default;
`;
